<template>

<app-wrapper>

    <app-inner :row="!window.is.mobile">

        <div class="recent-item is-blog">

            <div class="recent-item-title">{{ page.recent_blog_title }}</div>
            
            <router-link :to="{name: 'Blog'}" class="recent-item-box">

                <div class="recent-item-box-image" :style="{backgroundImage: 'url(' + page.recent.blog.image + ')'}">

                    <app-icon name="comments" class="recent-item-box-image-icon" />

                </div>
                
                <div class="recent-item-box-text">

                    <div class="recent-item-box-text-date">{{ page.recent.blog.date | formatDate('DD MMM YYYY') }}</div>
                    <div class="recent-item-box-text-name">{{ page.recent.blog.name }}</div>
                    <div class="recent-item-box-text-description">{{ page.recent.blog.description }}</div>

                </div>

            </router-link>

        </div>
        
        <div class="recent-item is-event">

            <div class="recent-item-title">{{ page.recent_events_title }}</div>
            
            <router-link :to="{name: 'Events'}" class="recent-item-box">

                <div class="recent-item-box-image" :style="{backgroundImage: 'url(' + page.recent.event.image + ')'}">

                    <app-icon name="calendar-o" class="recent-item-box-image-icon" />

                </div>
                
                <div class="recent-item-box-text">

                    <div class="recent-item-box-text-date">
                        {{ page.recent.event.date | formatDate('DD MMM YYYY') }}
                        <template v-if="page.recent.event.ends">
                            - {{ page.recent.event.ends | formatDate('DD MMM YYYY') }}
                        </template> 
                    </div>
                    <div class="recent-item-box-text-name">{{ page.recent.event.name }}</div>
                    <div class="recent-item-box-text-description">{{ page.recent.event.description }}</div>

                </div>

            </router-link>

        </div>

    </app-inner>

</app-wrapper>

</template>

<script>

export default {

}

</script>

<style scoped>

.recent-item {
    width: calc(50% - 20px);
    margin-top: 40px;
    display: flex;
    flex-direction: column;;
}

.is-tablet .recent-item {
    width: calc(50% - 10px);
    margin-top: 20px;
}

.is-mobile .recent-item {
    width: 100%;
    margin-top: 20px;
}

.recent-item:first-child {
    margin-right: 40px
}

.is-tablet .recent-item:first-child {
    margin-right: 20px
}

.is-mobile .recent-item:first-child {
    margin-right: 0px;
}

.recent-item-title {
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 20px;
    font-weight: 700;
    color: var(--color-grey);
    flex-shrink: 0;
}

.recent-item-box {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
}

.is-tablet .recent-item-box {
    margin-top: 20px;
    margin-bottom: 20px;
}

.is-mobile .recent-item-box {
    margin-top: 20px;
    padding: 10px;
    margin-bottom: 0px;
}

.is-mobile .recent-item:last-child .recent-item-box {
    margin-bottom: 20px;
}

.is-desktop .recent-item-box:hover {
    border-color: var(--color-grey-highlight);
}

.recent-item-box-image {
    width: 160px;
    height: 160px;
    border-radius: 4px;
	position: relative;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 20px;
    flex-shrink: 0;
}

.is-tablet .recent-item-box-image {
    width: 120px;
    height: 120px;
}

.is-mobile .recent-item-box-image {
    width: 64px;
    height: 64px;
}

.recent-item.is-blog .recent-item-box-image-icon {
    background-color: var(--color-yellow);
}

.recent-item.is-event .recent-item-box-image-icon {
    background-color: var(--color-red);
}

.recent-item-box-image-icon {
    position: absolute;
    left: 0px;
    top: 0px;
	border-radius: 4px 0px 0px 0px;
    font-size: 16px;
	width: 32px;
	height: 32px;
	line-height: 32px;
    text-align: center;
}

.recent-item.is-blog .recent-item-box-image-icon {
    color: #ff7200;
}

.recent-item.is-event .recent-item-box-image-icon {
    color: #91152d;
}

.recent-item-box-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.recent-item-box-text-date {
    text-align: right;
    color: var(--color-grey);
    font-size: 12px;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.recent-item-box-text-name {
    color: var(--color-grey-dark);
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
    font-family: grueber,serif;
}

.is-tablet .recent-item-box-text-name {
    font-size: 20px;
    line-height: 24px;
}

.is-mobile .recent-item-box-text-name {
    font-size: 20px;
    line-height: 24px;
}

.recent-item-box-text-description {
    color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
}

</style>
